"use strict";

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var Dataset = require("../../dataset");

var Expression = require("../../expression");

var DataflowTableGroupedContext =
/*#__PURE__*/
function () {
  function DataflowTableGroupedContext(table, indices) {
    _classCallCheck(this, DataflowTableGroupedContext);

    this.table = table;
    this.indices = indices;
  }

  _createClass(DataflowTableGroupedContext, [{
    key: "getVariable",
    value: function getVariable(name) {
      var _this = this;

      if (this.table.rows[this.indices[0]].hasOwnProperty(name)) {
        return this.indices.map(function (i) {
          return _this.table.rows[i][name];
        });
      }

      return this.table.getVariable(name);
    }
  }]);

  return DataflowTableGroupedContext;
}();

exports.DataflowTableGroupedContext = DataflowTableGroupedContext;

var DataflowTable =
/*#__PURE__*/
function () {
  function DataflowTable(parent, name, rows) {
    _classCallCheck(this, DataflowTable);

    this.parent = parent;
    this.name = name;
    this.rows = rows;
  }
  /** Implements Expression.Context */


  _createClass(DataflowTable, [{
    key: "getVariable",
    value: function getVariable(name) {
      if (name == "rows") {
        return this.rows;
      }

      return this.parent.getVariable(name);
    }
    /** Get a row with index */

  }, {
    key: "getRow",
    value: function getRow(index) {
      return this.rows[index];
    }
    /** Get a row context with index */

  }, {
    key: "getRowContext",
    value: function getRowContext(index) {
      return new Expression.ShadowContext(this, this.rows[index]);
    }
  }, {
    key: "getGroupedContext",
    value: function getGroupedContext(rowIndices) {
      return new DataflowTableGroupedContext(this, rowIndices);
    }
  }]);

  return DataflowTable;
}();

exports.DataflowTable = DataflowTable;

var DataflowManager =
/*#__PURE__*/
function () {
  function DataflowManager(dataset) {
    _classCallCheck(this, DataflowManager);

    this.context = new Dataset.DatasetContext(dataset);
    this.cache = new Expression.ExpressionCache();
    this.tables = new Map();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = dataset.tables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var table = _step.value;
        var dfTable = new DataflowTable(this, table.name, table.rows);
        this.tables.set(table.name, dfTable);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  /** Get a table by name (either original table or derived table) */


  _createClass(DataflowManager, [{
    key: "getTable",
    value: function getTable(name) {
      return this.tables.get(name);
    }
    /** Implements Expression.Context */

  }, {
    key: "getVariable",
    value: function getVariable(name) {
      if (this.tables.has(name)) {
        return this.tables.get(name).rows;
      }
    }
  }]);

  return DataflowManager;
}();

exports.DataflowManager = DataflowManager;